import React, {FC} from 'react';

import AemButton from '@/components/Aem/AemButton';
import {LOGIN_PAGE_REGISTER_BUTTON_ARIA_LABEL} from '@/consts/localization/localizationKeys';
import useExternalLink from '@/hooks/useExternalLink';
import {getAriaLabel} from '@/services/accessibilityService';
import type {ButtonModel} from '@/types/aem/buttonModel';

interface RegisterLinkProps {
    prefixText?: string;
    button?: ButtonModel;
}

const RegisterLink: FC<RegisterLinkProps> = ({prefixText, button}) => {
    const {alt, externalLink, ...rest} = button || {};
    // @ts-ignore
    const {redirect: redirectToRegister} = useExternalLink(externalLink);

    return (
        <div className='flex flex-wrap items-center justify-center gap-1 py-3 text-16 leading-[24px]'>
            <span>{prefixText}</span>

            <AemButton
                className='m-0 flex w-fit min-w-fit rounded-none p-0 text-16 font-bold underline'
                onClick={redirectToRegister}
                aria-label={alt || getAriaLabel(LOGIN_PAGE_REGISTER_BUTTON_ARIA_LABEL)}
                {...rest}
            />
        </div>
    );
};

export default RegisterLink;
